var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2844 14.2156C15.4252 14.3578 15.5042 14.5499 15.5042 14.75C15.5042 14.9501 15.4252 15.1422 15.2844 15.2844C15.141 15.423 14.9494 15.5005 14.75 15.5005C14.5506 15.5005 14.359 15.423 14.2156 15.2844L8 9.05938L1.78437 15.2844C1.64102 15.423 1.44941 15.5005 1.25 15.5005C1.05059 15.5005 0.85898 15.423 0.715625 15.2844C0.574789 15.1422 0.495781 14.9501 0.495781 14.75C0.495781 14.5499 0.574789 14.3578 0.715625 14.2156L6.94062 8L0.715625 1.78438C0.596028 1.63866 0.534909 1.45366 0.544156 1.26537C0.553404 1.07708 0.632357 0.898961 0.765658 0.76566C0.898959 0.632359 1.07708 0.553406 1.26537 0.544158C1.45366 0.534911 1.63865 0.59603 1.78437 0.715627L8 6.94063L14.2156 0.715627C14.3613 0.59603 14.5463 0.534911 14.7346 0.544158C14.9229 0.553406 15.101 0.632359 15.2343 0.76566C15.3676 0.898961 15.4466 1.07708 15.4558 1.26537C15.4651 1.45366 15.404 1.63866 15.2844 1.78438L9.05937 8L15.2844 14.2156Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.66f17bf9067c7080652893fd2de7b754.svg";
export { ForwardRef as ReactComponent };